import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { x: Number, y: Number }

  connect() {
    this.observer = new ResizeObserver(() => this.position())
    this.observer.observe(this.element)
    this.position()
  }

  disconnect() {
    this.observer.disconnect()
  }

  xValueChanged() { this.position() }
  yValueChanged() { this.position() }

  position() {
    const active = this.hasXValue && this.hasYValue
    this.element.toggleAttribute("data-focal-image-active", active)
    if (!active) {
      this.element.style.removeProperty("object-position")
      return
    }

    const image = this.element
    if (!image.naturalWidth || !image.naturalHeight) return
    const width = image.clientWidth
    const height = image.clientHeight
    const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight)
    const offset = (size, rendered, point) => Math.min(0, Math.max(size - rendered, size / 2 - rendered * point / 100))
    image.style.objectPosition = `${offset(width, image.naturalWidth * scale, this.xValue)}px ${offset(height, image.naturalHeight * scale, this.yValue)}px`
  }
}
